import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmn-brand',
    templateUrl: './brand.component.html',
    styleUrls: [ './brand.component.scss' ],
})

export class BrandComponent {
    @Input() public readonly link: string;
    @Input() public readonly image: string;
}
